import { faSlidersSolid } from '@/lib/fa'
import CheckboxWithLabelField from '@/modules/drivers/forms/contract/inputs/CheckboxWithLabelField'
import { Divider } from '@/modules/drivers/forms/shared/Divider'
import StageHeader from '@/modules/drivers/forms/shared/StageHeader'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import React from 'react'

const Options = ({ data, setData, vehicleActivity, separateFilesOnly }) => {
  const { t } = useLocalize()
  return (
    <div className="tw-flex tw-items-start">
      <StageHeader title={t('printout.options')} textSize="sm" icon={faSlidersSolid} />
      <div className="tw-flex tw-flex-1 tw-flex-col tw-gap-1 sm:tw-min-w-[400px]">
        {vehicleActivity && (
          <>
            <CheckboxWithLabelField
              field="onlyForActiveVehicles"
              data={data}
              setData={setData}
              label={t('printout.only-active-vehicles')}
            />
            <Divider />
          </>
        )}
        <CheckboxWithLabelField
          field="separateFiles"
          data={data}
          setData={setData}
          label={t('printout.print-to-separate-files')}
        />
        {/* 
        {!separateFilesOnly && (
          <>
            <CheckboxWithLabelField
              field="issuerSignature"
              data={data}
              setData={setData}
              label={t('printout.issuer-signature')}
            />
            <CheckboxWithLabelField
              field="driverSignature"
              data={data}
              setData={setData}
              label={t('printout.driver-signature')}
            />
          </>
        )}
        */}
      </div>
    </div>
  )
}

export default Options
